import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux'
import Toast from './components/Toast'
import Login from './containers/Login'
import Spinner from './components/Spinner'
import './index.css'
import {
  setUserInfo,
  toggleSnackBar
} from './redux/actions'
import ChangePassword from './containers/ChangePassword'
import Main from './containers/Main'
import Home from './containers/Home'
import Settings from './containers/Settings'
import Reports from './containers/Reports'


import { Car } from './containers/Car'
import { Scan } from './containers/Scan'
import { Sketch } from './containers/Scan/Sketch'
import { CarReport } from './containers/CarReport'
import { Report } from './containers/CarReport/Report'
import Verify from './containers/Verify'


const mapDispatchToProps = dispatch => ({
  setLogin: user => dispatch(setUserInfo(user)),
  toggleSnackBar: msg => dispatch(toggleSnackBar(msg)),
})

const mapStateToProps = state => {
  return {
    app: state.app,
    user: state.user,
    modals: state.modals
  }
}

class MainApp extends Component {


  UNSAFE_componentWillMount = () => {
    let { setLogin, history, user } = this.props;
    let token = localStorage.getItem('token');
    if (user.loggedIn) return;
    if (window.location.pathname === "/verify") return;
    if (!token) return history.push("/login");
    try {
      let i = token.split('.')
      let userInfo = JSON.parse(decodeURIComponent(atob(i[1]).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join('')))
      let user = { ...userInfo, token }
      setLogin(user)
    } catch (e) {
      console.error(e)
      return history.push("/login");
    }
  }


  render() {
    let {
      app,
      user
    } = this.props;
    return (
      <span>
        {user.loggedIn && <Home />}
        <Spinner loading={app.loading} />
        <Toast />
        <Switch>
          <Route exact path="/" component={Main} />
          <Route path="/login" component={Login} />
          <Route path="/verify" component={Verify} />
          <Route path="/car" component={Car} />
          <Route path="/scan" component={Scan} />
          <Route path="/sketch" component={Sketch} />
          <Route path="/carReport" component={CarReport} />
          <Route path="/writeReport" component={Report} />
          <Route path="/changepassword" component={ChangePassword} />
          <Route path="/reports" component={Reports} />
          <Route path="/settings" component={Settings} />
        </Switch>
      </span>
    );
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MainApp))